(function() {
	var App = angular.module('pphhApp');

	App.service("closeVersionActionController", ["$mdDialog", "$window", "CRUDService", "pphhEnv",
		CloseVersionActionController]);

	/**
	 * Controlador de la acción de cierre de versión por defecto.
	 */
	function CloseVersionActionController($mdDialog, $window, crudService, pphhEnv) {
		this.performAction = performAction;

		function performAction(scope) {

			var confirm = $mdDialog.confirm()
				.clickOutsideToClose(true)
				.title(UIMessages.dialog.confirm.title)
				.htmlContent(UIMessages.visor.close)
				.ok(UIMessages.dialog.confirm.ok)
				.cancel(UIMessages.dialog.confirm.cancel)
				;
			$mdDialog.show(confirm)
				.then(
					function() {
						closeCicloCallback(scope);
					});
		}

		function closeCicloCallback(scope) {
			scope.isLoading = true;
			crudService.closeCiclo()
				.then(
					function(response) {
						if (response.data) {
							$window.location.href = pphhEnv.global.contextPath + "/pphh-sgpusa-init?wm=" + scope.waterModule.key
						} else {
							var alert = $mdDialog.alert()
								.clickOutsideToClose(true)
								.title(UIMessages.dialog.confirm.title)
								.htmlContent(UIMessages.visor.unableToClose)
								.ok(UIMessages.dialog.confirm.ok)
								;
							$mdDialog.show(alert);
						}
					},
					function(response) {
						scope.isLoading = false;
						if (response.data.needYear) {
							showSelectYearDialog(scope);
						}
					}
				);
		}

		function showSelectYearDialog(scope) {
			$mdDialog.show({
				clickOutsideToClose: true,
				escapeToClose: true,
				controller: "versionSelectYearDialogController",
				templateUrl: _contextPath + "/pphhNav/selectYearDialog-init",
				locals:{params:{wm: scope.waterModule.key}}
			}).then(function (res) {
		});
	}

	}

	

	/*

	App.controller("selectYearDialogController", ["$scope", "$mdDialog", "$http", SelectYearDialogController]);
*/
})();